import $ from 'jquery'
import JsAlert from 'js-alert'

const main = () => {
    if(document.getElementById('page-topics') === null) return
    // ...
}

export default main